/**
 * Created by zhaoy on 2020/7/13
 * Desc: 学生名单布局
 */

import React, {Component} from 'react'
import 'css/roster-item.css'
import {Modal, Toast} from "antd-mobile";
import {fetchGet, fetchPost} from "../utils/fetchRequest";
import {API} from "../configs/api.config";

const {alert} = Modal

export default class CardLoseItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            albumBean: props.albumBean,
        }
    }

    componentDidMount() {
        this.setState({
            albumBean: this.props.albumBean
        })
    }

    render() {
        const {albumBean} = this.state
        return (
            <div className='header_days_sty'>

                <div className='each_day_ic'>{albumBean.stuName}</div>
                <div className='each_day_ic'>{albumBean.changType}</div>
                <div className='each_day_ic'>{albumBean.changType==='正常'?<button style={{borderRadius:5,color:"#333333",fontSize:18}} onClick={this.doApprovel.bind(this,albumBean.stuId)}>挂失</button>:'无操作'}</div>

            </div>

        )
    }

    doApprovel = (stuId)=>{
        this.setState({
            AMvisible: false,
        });
        alert('', '确认挂失当前卡吗？挂失后卡片将无法进行消费', [
            {
                text: '取消', onPress: () => {
                }
            },
            {
                text: '确定', onPress: () => {
                    if(stuId == 0){
                        return
                    }

                    let params = {
                        stuId:stuId
                    }
                    console.log("params",params)
                    fetchPost(API.STUDENTS_CARD_LOSE,params,{}).then((response)=>{
                        if(response.success){
                            let model=this.state.albumBean
                            model.changType="挂失中"
                            this.setState({
                                albumBean: model
                            })


                            Toast.show(response.data)
                        }else{
                            Toast.fail(response.message,2)
                        }
                    }).catch((error) =>{
                        if (typeof error === 'string') {
                            Toast.fail(error, 2)
                        } else {
                            Toast.fail('请求异常', 2)
                        }
                    })
                }
            }
        ])

    }

}